import './ServicesLandingPage.scss';
import '../../../../Sections/Contact/Contact'
import '../../../../Sections/Map/Map'
import FormRedirection from '../../../../../common/scripts/FormRedirection';
import { auto } from '@popperjs/core';


ComponentManager.init(document.body);
FormRedirection.init()

jQuery(function ($) {
    $('.SLP_Platforms__navs-mobile').slick({
        variableWidth: true,
        focusOnSelect: true,
        prevArrow: false,
        nextArrow: false
    });
})
